<template>
    <button class="group flex items-center gap-3 cursor-pointer" type="button" @click="show">
        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
             class="pointer-events-none size-5 text-gray-400">
            <path
                d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z"
                clip-rule="evenodd" fill-rule="evenodd"/>
        </svg>
        <span
            class="inline bg-white text-base text-gray-900 outline-hidden placeholder:text-gray-400 sm:text-sm/6 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-500">
            Search
        </span>
        <span
            class="px-2 flex items-center gap-1 rounded-lg border border-gray-300 text-gray-300 group-hover:border-brand-400 group-hover:text-brand-400">
            <kbd v-html="metaSymbol"/>
            <kbd class="text-sm">K</kbd>
        </span>
        <Teleport to="body">
            <el-dialog>
                <dialog ref="dialog" class="backdrop:bg-transparent">
                    <el-dialog-backdrop
                        class="fixed inset-0 bg-gray-500/25 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in dark:bg-gray-900/50"></el-dialog-backdrop>

                    <div tabindex="0"
                         class="fixed inset-0 w-screen overflow-y-auto focus:outline-none sm:p-6 md:p-20">
                        <el-dialog-panel
                            class="relative mx-auto flex flex-col justify-between max-w-xl max-h-screen transform overflow-hidden h-screen md:h-auto md:rounded-xl bg-white shadow-2xl outline-1 outline-black/5 transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in data-closed:sm:translate-y-0 data-closed:sm:scale-95 dark:bg-gray-900 dark:-outline-offset-1 dark:outline-white/10">
                            <div class="relativ overflow-hidden">

                                <ais-instant-search
                                    :search-client="searchClient"
                                    :index-name="indexPrefix + '::articles'"
                                    class="relative flex flex-col h-full"
                                >
                                    <ais-configure
                                        :hitsPerPage="5"
                                        highlightPreTag="<span class='text-brand-400 group-aria-selected:text-white group-aria-selected:underline'>"
                                    />
                                    <ais-search-box>
                                        <template v-slot="{ currentRefinement, isSearchStalled, refine }">
                                            <div class="grid grid-cols-1">
                                                <input type="search"
                                                       :value="currentRefinement"
                                                       @input="refine($event.currentTarget.value)"
                                                       @keydown.down.prevent="nextResult"
                                                       @keydown.up.prevent="previousResult"
                                                       @keydown.enter.prevent="navigateTo"
                                                       autofocus
                                                       placeholder="Search..."
                                                       class="col-start-1 row-start-1 h-12 w-full pr-4 pl-11 text-base text-gray-900 outline-hidden placeholder:text-gray-400 sm:text-sm dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-500"/>
                                                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon"
                                                     aria-hidden="true"
                                                     class="pointer-events-none col-start-1 row-start-1 ml-4 size-5 self-center text-gray-400 dark:text-gray-500">
                                                    <path
                                                        d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z"
                                                        clip-rule="evenodd" fill-rule="evenodd"/>
                                                </svg>
                                            </div>
                                        </template>
                                    </ais-search-box>


                                    <ais-state-results ref="articles" class="relative overflow-x-auto">
                                        <template v-slot="{ state: { query }, results: { hits } }">
                                            <div v-if="query.length === 0"
                                                 class="block border-t border-gray-100 px-6 py-14 text-center text-sm sm:px-14 dark:border-white/10">
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                     stroke-width="1.5" data-slot="icon"
                                                     aria-hidden="true"
                                                     class="mx-auto size-6 text-gray-400 dark:text-gray-500">
                                                    <path
                                                        d="m6.115 5.19.319 1.913A6 6 0 0 0 8.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 0 0 2.288-4.042 1.087 1.087 0 0 0-.358-1.099l-1.33-1.108c-.251-.21-.582-.299-.905-.245l-1.17.195a1.125 1.125 0 0 1-.98-.314l-.295-.295a1.125 1.125 0 0 1 0-1.591l.13-.132a1.125 1.125 0 0 1 1.3-.21l.603.302a.809.809 0 0 0 1.086-1.086L14.25 7.5l1.256-.837a4.5 4.5 0 0 0 1.528-1.732l.146-.292M6.115 5.19A9 9 0 1 0 17.18 4.64M6.115 5.19A8.965 8.965 0 0 1 12 3c1.929 0 3.716.607 5.18 1.64"
                                                        stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                <p class="mt-4 font-semibold text-gray-900 dark:text-white">
                                                    Search articles, the bibliography and glossary
                                                </p>
                                                <p class="mt-2 text-gray-500 dark:text-gray-400">
                                                    Quickly find relevant material to help with your understanding of
                                                    geochemical interpretation.
                                                </p>
                                            </div>
                                            <div v-else
                                                 class="block md:max-h-120 scroll-pt-11 scroll-pb-2 space-y-2 overflow-y-auto pb-2">
                                                <div aria-labelledby="articles-label" class="block">
                                                    <div id="articles-label"
                                                         class="sticky top-0 z-10 bg-gray-100 px-4 py-2.5 text-xs font-semibold text-gray-900 dark:bg-white/5 dark:text-white">
                                                        Articles
                                                    </div>
                                                    <div class="mt-2 text-sm text-gray-800 dark:text-gray-300">
                                                        <a :href="item.url"
                                                           v-if="hits.length > 0"
                                                           v-for="item in hits"
                                                           :key="item.objectID"
                                                           :id="'articles-' + item.objectID"
                                                           ref="links"
                                                           class="group block px-4 py-2 select-none focus:outline-hidden aria-selected:bg-brand-400 aria-selected:text-white dark:aria-selected:bg-brand-500"
                                                           :aria-selected="'articles-' + item.objectID === itemId"
                                                           @mouseenter="selectItem('articles-' + item.objectID)"
                                                        >
                                                            <span class="block font-semibold"
                                                                  v-html="item._highlightResult.title.value"/>
                                                            <span class="block text-xs"
                                                                  v-html="item._snippetResult.content.value"/>
                                                        </a>
                                                        <div v-else class="px-4 py-2 text-center">There are no results that match your query.</div>
                                                    </div>
                                                </div>

                                                <ais-index v-if="hasBibliography"
                                                           :index-name="indexPrefix + '::bibliography'">
                                                    <div aria-labelledby="bibliography-label" class="block">
                                                        <div id="bibliography-label"
                                                             class="sticky top-0 z-10 bg-gray-100 px-4 py-2.5 text-xs font-semibold text-gray-900 dark:bg-white/5 dark:text-white">
                                                            Bibliography
                                                        </div>
                                                        <div class="mt-2 text-sm text-gray-800 dark:text-gray-300">
                                                            <ais-state-results ref="bibliography">
                                                                <template v-slot="{ results: { hits } }">
                                                                    <a :href="item.url"
                                                                       v-if="hits.length > 0"
                                                                       v-for="item in hits"
                                                                       :key="item.objectID"
                                                                       :id="'bibliography-' + item.objectID"
                                                                       ref="links"
                                                                       class="group block px-4 py-2 select-none focus:outline-hidden aria-selected:bg-brand-400 aria-selected:text-white dark:aria-selected:bg-brand-500"
                                                                       :aria-selected="'bibliography-' + item.objectID === itemId"
                                                                       @mouseenter="selectItem('bibliography-' + item.objectID)"
                                                                    >
                                                                        <span class="block font-semibold"
                                                                              v-html="item._highlightResult.title.value"/>
                                                                        <span class="block text-xs">
                                                                            <span v-html="item.authors"/>
                                                                            ({{ item.year }})
                                                                        </span>
                                                                    </a>
                                                                    <div v-else class="px-4 py-2 text-center">There are no results that match your query.</div>
                                                                </template>
                                                            </ais-state-results>
                                                        </div>
                                                    </div>
                                                </ais-index>

                                                <ais-index v-if="hasGlossary" :index-name="indexPrefix + '::glossary'">
                                                    <div aria-labelledby="glossary-label" class="block">
                                                        <div id="glossary-label"
                                                             class="sticky top-0 z-10 bg-gray-100 px-4 py-2.5 text-xs font-semibold text-gray-900 dark:bg-white/5 dark:text-white">
                                                            Glossary
                                                        </div>
                                                        <div class="mt-2 text-sm text-gray-800 dark:text-gray-300">
                                                            <ais-state-results ref="glossary">
                                                                <template v-slot="{ results: { hits } }">
                                                                    <a :href="item.url"
                                                                       v-if="hits.length > 0"
                                                                       v-for="item in hits"
                                                                       :key="item.objectID"
                                                                       :id="'glossary-' + item.objectID"
                                                                       ref="links"
                                                                       class="group block px-4 py-2 select-none focus:outline-hidden aria-selected:bg-brand-400 aria-selected:text-white dark:aria-selected:bg-brand-500"
                                                                       :aria-selected="'glossary-' + item.objectID === itemId"
                                                                       @mouseenter="selectItem('glossary-' + item.objectID)"
                                                                    >
                                                                        <span
                                                                            class="block font-semibold"
                                                                            v-html="item._highlightResult.term.value"
                                                                        />
                                                                        <span
                                                                            class="block text-xs"
                                                                            v-html="item._snippetResult.description.value"
                                                                        />
                                                                    </a>
                                                                    <div v-else class="px-4 py-2 text-center">There are no results that match your query.</div>
                                                                </template>
                                                            </ais-state-results>
                                                        </div>
                                                    </div>
                                                </ais-index>
                                            </div>
                                        </template>
                                    </ais-state-results>
                                </ais-instant-search>
                            </div>
                            <div
                                class="flex flex-wrap items-center shadow-[0_-1px_0_0_#e0e3e8,_0_-3px_6px_0_#45629b1f] bg-gray-50 px-4 py-2.5 text-xs text-gray-700 dark:bg-gray-800/50 dark:text-gray-300">
                                <span class="hidden md:flex md:items-center">
                                    Type
                                    <kbd
                                        class="mx-1 flex size-5 select-none items-center justify-center rounded-sm border border-gray-400 bg-white font-semibold text-gray-900 in-data-[mode=project]:border-brand-600 in-data-[mode=project]:text-brand-600 sm:mx-2 dark:border-white/10 dark:bg-gray-800 dark:text-white dark:in-data-[mode=project]:border-brand-500 dark:in-data-[mode=project]:text-brand-500">&crarr;</kbd>
                                    to select
                                    <kbd
                                        class="ml-1 flex size-5 select-none items-center justify-center rounded-sm border border-gray-400 bg-white font-semibold text-gray-900 in-data-[mode=user]:border-brand-600 in-data-[mode=user]:text-brand-600 sm:mx-2 dark:border-white/10 dark:bg-gray-800 dark:text-white dark:in-data-[mode=user]:border-brand-500 dark:in-data-[mode=user]:text-brand-500">&uarr;</kbd>
                                    <kbd
                                        class="mr-1 flex size-5 select-none items-center justify-center rounded-sm border border-gray-400 bg-white font-semibold text-gray-900 in-data-[mode=user]:border-brand-600 in-data-[mode=user]:text-brand-600 sm:mr-2 dark:border-white/10 dark:bg-gray-800 dark:text-white dark:in-data-[mode=user]:border-brand-500 dark:in-data-[mode=user]:text-brand-500">&darr;</kbd>
                                    to navigate
                                    <kbd
                                        class="mx-1 flex size-5 select-none items-center justify-center rounded-sm border border-gray-400 bg-white font-semibold text-gray-900 in-data-[mode=help]:border-brand-600 in-data-[mode=help]:text-brand-600 sm:mx-2 dark:border-white/10 dark:bg-gray-800 dark:text-white dark:in-data-[mode=help]:border-brand-500 dark:in-data-[mode=help]:text-brand-500">&#x241b;</kbd>
                                    to close
                                </span>

                                <ais-powered-by class="ml-auto"/>
                            </div>
                        </el-dialog-panel>
                    </div>
                </dialog>
            </el-dialog>
        </Teleport>
    </button>
</template>

<script setup>
    import {computed, onMounted, onUnmounted, ref, useTemplateRef} from "vue";
    import {algoliasearch} from "algoliasearch";

    const props = defineProps({
        appId: {
            type: String,
            default: ''
        },
        apiKey: {
            type: String,
            default: ''
        },
        indexes: {
            type: Array,
            default: () => []
        },
        indexPrefix: {
            type: String,
            default: 'ignet.test',
        },
        glossaryUrl: String,
    })

    const dialog = useTemplateRef('dialog');
    const links = useTemplateRef('links');
    const articles = useTemplateRef('articles');
    const bibliography = useTemplateRef('bibliography');
    const glossary = useTemplateRef('glossary');

    const itemIndex = ref(-1);
    const itemId = ref(null);

    const isMac = computed(() => navigator.platform.startsWith("Mac") || navigator.platform === "iPhone")

    const metaSymbol = computed(() => {
        if (isMac.value) {
            return '&#8984;'; // Mac OS
        } else {
            return 'Ctrl'; // Windows
        }
    })

    const hasBibliography = computed(() => props.indexes.includes('bibliography'));
    const hasGlossary = computed(() => props.indexes.includes('glossary'));

    const items = computed(() => {
        let results = articles.value.stateResults.hits.map((item) => {
            item.listID = 'articles-' + item.objectID;
            return item;
        });

        if (hasBibliography.value) {
            results = results.concat(bibliography.value.stateResults.hits.map((item) => {
                item.listID = 'bibliography-' + item.objectID;
                return item;
            }));
        }

        if (hasGlossary.value) {
            results = results.concat(glossary.value.stateResults.hits.map((item) => {
                item.listID = 'glossary-' + item.objectID;
                return item;
            }));
        }

        return results;
    });

    const algoliaClient = algoliasearch(
        props.appId,
        props.apiKey
    );

    const searchClient = ref({
        ...algoliaClient,
        search(requests) {
            if (requests.every(({params}) => !params.query)) {
                return Promise.resolve({
                    results: requests.map(() => ({
                        hits: [],
                        nbHits: 0,
                        nbPages: 0,
                        page: 0,
                        processingTimeMS: 0,
                        hitsPerPage: 0,
                        exhaustiveNbHits: false,
                        query: "",
                        params: "",
                    })),
                });
            }

            return algoliaClient.search(requests);
        },
    });

    function show() {
        dialog.value.show();
    }

    function selectItem(id) {
        itemIndex.value = items.value.findIndex((item) => item.listID === id);
        itemId.value = id;
    }

    function nextResult() {
        if (itemIndex.value >= -1 && itemIndex.value < (items.value.length - 1)) {
            itemIndex.value++;

            const item = items.value.at(itemIndex.value);
            itemId.value = item.listID;

            const link = links.value.find((link) => link.id === item.listID);

            link.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                container: "nearest",
            });
        }
    }

    function previousResult() {
        if (itemIndex.value >= 1 && itemIndex.value < items.value.length) {
            itemIndex.value--;
            itemId.value = items.value.at(itemIndex.value).listID;

            const item = items.value.at(itemIndex.value);
            const link = links.value.find((link) => link.id === item.listID);

            link.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                container: "nearest",
            });
        }
    }

    function navigateTo() {
        window.location = items.value.at(itemIndex.value).url;
    }

    function onGlobalKeydown(event) {
        if (
            isMac.value && event.metaKey && event.key === 'k'
            || !isMac.value && event.ctrlKey && event.key === 'k'
        ) {
            show()
        }
    }

    onMounted(() => {
        window.addEventListener('keydown', onGlobalKeydown);
    });

    onUnmounted(() => {
        window.removeEventListener('keydown', onGlobalKeydown);
    })
</script>
